import { EditGPDAddReportTask, GPDAddReportTask } from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickGpdLibraryFields } from "../../../schema/gpd-schema-library";

const sharedTitle = (type: FormType | undefined) => `GPD-Rapport Toevoegen ${getTitleAddon(type)}`;
const sharedDescription = `Dit is het GPD Rapport formulier. Upload het template en controleer de waarden in de tabel. ${getDocsLinkMarkdown(
  "GPD"
)}`;

const getGpdAddReportCreateSchema = (
  type: FormType | undefined
): SchemaForFormData<GPDAddReportTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      required: ["projectNumber", "broId", "qualityRegime", "deliveryAccountableParty"],
      properties: pickGpdLibraryFields([
        "projectNumber",
        "broId",
        "qualityRegime",
        "deliveryAccountableParty",
      ]),
    },
    ...pickGpdLibraryFields(["volumeFile"]),
    sourcedocumentData: {
      type: "object",
      required: ["reportId", "method", "volumeSeries", "groundwaterUsageFacilityBroId"],
      properties: pickGpdLibraryFields([
        "reportId",
        "method",
        "groundwaterUsageFacilityBroId",
        "volumeSeries",
      ]),
    },
  },
});

const getGpdAddReportEditSchema = (
  type: FormType | undefined
): SchemaForFormData<EditGPDAddReportTask> => ({
  type: "object",
  title: sharedTitle(type),
  description: sharedDescription,
  required: ["metadata", "sourcedocumentData", "timeseriesFile"],
  properties: {
    metadata: {
      type: "object",
      required: [
        "projectNumber",
        "broId",
        "qualityRegime",
        "deliveryAccountableParty",
        "correctionReason",
      ],
      properties: {
        ...pickGpdLibraryFields([
          "projectNumber",
          "qualityRegime",
          "deliveryAccountableParty",
          "correctionReason",
        ]),
        broId: { ...pickGpdLibraryFields(["broId"]).broId, readOnly: true },
      },
    },
    ...pickGpdLibraryFields(["volumeFile"]),
    sourcedocumentData: {
      type: "object",
      required: ["reportId", "method", "volumeSeries", "groundwaterUsageFacilityBroId"],
      properties: pickGpdLibraryFields([
        "reportId",
        "method",
        "groundwaterUsageFacilityBroId",
        "volumeSeries",
      ]),
    },
  },
});

export function getGpdAddReportSchema(args: {
  type: FormType | undefined;
  isEditing: true;
}): SchemaForFormData<EditGPDAddReportTask>;
export function getGpdAddReportSchema(args: {
  type: FormType | undefined;
  isEditing: false;
}): SchemaForFormData<GPDAddReportTask>;
export function getGpdAddReportSchema(args: {
  type: FormType | undefined;
  isEditing: boolean;
}): SchemaForFormData<EditGPDAddReportTask> | SchemaForFormData<GPDAddReportTask>;
export function getGpdAddReportSchema({
  type,
  isEditing,
}: {
  type: FormType | undefined;
  isEditing: boolean;
}) {
  return isEditing ? getGpdAddReportEditSchema(type) : getGpdAddReportCreateSchema(type);
}
